//
// Brand Menu
//
// Finds brand grid element with highest height value and applies that value to all other brand grid elements
//
//

function getMaxHeight(className) {
  let max = 0;
  document.querySelectorAll(className).forEach(function (el) {
    if (el.scrollHeight > max) {
      max = el.scrollHeight;
    }
  });

  return max;
}

function setHeight(className, height) {
  document.querySelectorAll(className).forEach(function (el) {
    el.style.height = height + 'px';
  });
}

let max = getMaxHeight('.brand-item__item--wrapper');

setHeight('.brand-item__item--wrapper', max);
